import apiFactory from './api';

const api = apiFactory({
  api_url: process.env.REACT_APP_API_URL || 'https://api.pro.agroger.com.br',
  has_user_header: true,
});

export default api;
